import { IMeeting } from "@mctypes/meeting.types";
import { STANDARD_COLORS } from "../../../globalConstants";
import { MeetingSeriesStatusEnums } from "./meetingSeriesConstants";
import { ICalenderEvent } from "./types";

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const setTime = (date: Date, time: string | undefined, fallbackMinuteTime?: string): Date => {
  const [hour = "0", minute = "0"] = (time ?? "").split(":");
  const [, fallbackMinute = minute] = (fallbackMinuteTime ?? "").split(":");
  const next = new Date(date);
  next.setHours(Number(hour), Number(fallbackMinute), 0, 0);
  return next;
};

const addDays = (date: Date, days: number): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate() + days, date.getHours(), date.getMinutes());

const diffInDays = (start: Date, end: Date): number => {
  const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate()).getTime();
  const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate()).getTime();
  return Math.round((endDay - startDay) / MS_PER_DAY);
};

const getWeekNumber = (date: Date): number => {
  const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
  const daysSinceFirstDay = Math.floor((date.getTime() - firstDayOfYear.getTime()) / MS_PER_DAY);
  return Math.ceil((daysSinceFirstDay + firstDayOfYear.getDay() + 1) / 7);
};

export const convertMeetingSeriesToCalenderEvent = (meetingSerie: IMeeting.MeetingSerie): ICalenderEvent[] => {
  const startDate = new Date(meetingSerie.seriesStart);
  const endDate = new Date(meetingSerie.seriesEnd);

  const calenderEvents: ICalenderEvent[] = [];
  if (meetingSerie.seriesEnd == null) {
    const startTime = setTime(startDate, meetingSerie.timeStart, meetingSerie.timeEnd);
    const endTime = setTime(startDate, meetingSerie.timeEnd);
    calenderEvents.push({
      title: `${meetingSerie.name}`,
      description: meetingSerie.description,
      start: startTime.toISOString(), // 2021-03-25T14:00:00
      end: endTime.toISOString(),
      color: "gray",
      status: meetingSerie.status as MeetingSeriesStatusEnums,
    });
  } else {
    const nrOfDays = Math.abs(diffInDays(startDate, endDate));

    const weekDayOfStartDate = startDate.getDay();

    for (let i = 0; i < nrOfDays; i++) {
      const d1 = addDays(startDate, i);
      const d2 = addDays(startDate, i);
      const weekDay = d1.getDay();
      const weeknumber = getWeekNumber(d1);
      if (weekDayOfStartDate === weekDay && isIntervalWeekValid(meetingSerie.interval, startDate, weeknumber)) {
        const startTime = setTime(d1, meetingSerie.timeStart);
        const endTime = setTime(d2, meetingSerie.timeEnd);
        calenderEvents.push({
          title: `${meetingSerie.name}`,
          description: meetingSerie.description,
          start: startTime.toISOString(), // 2021-03-25T14:00:00
          end: endTime.toISOString(),
          color: STANDARD_COLORS[meetingSerie.color],
          status: meetingSerie.status as MeetingSeriesStatusEnums,
        });
      }
    }
  }

  return calenderEvents;
};

const isIntervalWeekValid = (interval: string, startDate: any, week: number): boolean => {
  if (interval === "1") {
    return true;
  }

  if (interval === "2") {
    const weeknumber = getWeekNumber(startDate);

    const startWeekIsEven = weeknumber % 2 === 0;
    const weekIsEven = week % 2 === 0;
    return startWeekIsEven === weekIsEven;
  }

  return false;
};
